import { connect } from "react-redux";
import {
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import moment from "moment";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { errorToast, successToast } from "../../helpers/Notification";
import { getError, getSuccessMessage } from "store/helpers/common_functions";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";

const CommentManager = ({
  isSubTask,
  task,
  FetchDetails,
  taskId,
  open,
  SubmitGeneralForm,
  loggedUser,
  onClose,
  onSuccess,
  systemSettings
}) => {
  const mainBackground = systemSettings?.mainBackground;

  const [sendingChats, setSendingChats] = useState(false);
  const [loadingChats, setLoadingChats] = useState(false);
  const [replyToCommentId, setReplyToCommentId] = useState(null);
  const [comments, setComments] = useState(task?.task_comments ?? []);
  const chatRef = useRef(null);

  // Function to submit a new chat/comment
  const submitChats = async (data) => {
    setSendingChats(true);
    const resp = await SubmitGeneralForm(`/api/task/comment`, data);
    if (resp.status) {
      chatRef.current?.reset();
      onSuccess();
      successToast(getSuccessMessage(resp));
      loadingData();
    } else {
      errorToast(getError(resp));
    }
    setSendingChats(false);
  };

  const submitReply = async (commentId, content) => {
    const resp = await SubmitGeneralForm(`/api/task/comment`, {
      taskId: taskId ?? task.taskId,
      content,
      parentCommentId: commentId,
      subTaskId: isSubTask ? task.id : null,
    });
    if (resp.status) {
      onSuccess();
      successToast(getSuccessMessage(resp));
      loadingData();
    } else {
      errorToast(getError(resp));
    }
  };

  const loadingData = async () => {
    setLoadingChats(true);
    const resp = await FetchDetails(
      isSubTask
        ? `/api/task/comment/subTask/list/${task.id}`
        : `/api/task/comment/list/${taskId}`
    );
    if (resp.status) {
      setComments(resp?.data?.taskComments ?? []);
      setLoadingChats(false);
    } else {
      errorToast(getError(resp));
    }
  };

  useEffect(() => {
    if (open) {
      loadingData();
    }
  }, [open]);

  const className =
    "border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150";

  // Function to render replies for a comment
  const renderReplies = (replies) => {
    return replies.map((reply) => (
      <div key={reply.id} style={{ marginLeft: "20px", marginBottom: "10px" }}>
        <Chip
          label={
            <Typography style={{ whiteSpace: "normal", fontSize: "14px" }}>
              {reply.content}
            </Typography>
          }
          style={{ backgroundColor: "#e0f7fa", margin: "0 8px" }} // Different color for replies
        />
        <div style={{ fontSize: "12px", color: "#888", marginLeft: "5px" }}>
          {reply.commenter.names} at {moment(reply.commentedAt).format("HH:mm")}
        </div>
      </div>
    ));
  };

  const content = (
    <>
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold leading-normal text-blueGray-700">
          Comments
        </h3>
        {/* <Button onClick={onClose} variant="outlined" color="primary">
          Close
        </Button> */}
        <IconButton onClick={ onClose } style={{ marginLeft: "10px" }}>
          <img
            src={require("assets/icons/close.svg").default}
            alt={"close"}
          />
        </IconButton>
      </div>
      <div
        style={{
          height: "450px",
          overflowY: "auto",
          padding: "1rem",
          backgroundColor: "#f9f9f9",
          borderRadius: "8px",
        }}
      >
        {comments?.length <= 0 || loadingChats ? (
          <div className="text-center flex items-center justify-center h-full">
            <div>
              {loadingChats ? (
                <CircularProgress />
              ) : (
                <>
                  <InfoOutlined />
                  <div>No comments available!</div>
                </>
              )}
            </div>
          </div>
        ) : (
          <div>
            {comments?.map((comment, index) => {
              const isUserSender =
                loggedUser.resourceId === comment.commenterId.id;

              return (
                <div
                  key={comment.id}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: isUserSender ? "flex-end" : "flex-start",
                    }}
                  >
                    <Chip
                      label={
                        <Typography
                          style={{ whiteSpace: "normal", fontSize: "14px" }}
                        >
                          {comment.content}
                        </Typography>
                      }
                      style={{
                        backgroundColor: isUserSender ? "#e0f7fa" : "#ffe0b2",
                        margin: "0 8px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: isUserSender ? "flex-end" : "flex-start",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        marginRight: "10px",
                      }}
                    >
                      {comment.commenter.names} at{" "}
                      {moment(comment.commentedAt).format(
                        moment(comment.commentedAt).isSame(moment(), "day")
                          ? "HH:mm"
                          : "YYYY MMM DD"
                      )}
                    </span>
                    <Button
                      onClick={() => setReplyToCommentId(comment.id)}
                      color="primary"
                      size="small"
                    >
                      Reply
                    </Button>
                  </div>
                  {replyToCommentId === comment.id && (
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        const data = new FormData(e.currentTarget);
                        submitReply(comment.id, data.get("replyContent"));
                        setReplyToCommentId(null); // Reset reply state
                      }}
                      style={{ marginTop: "5px", display: "flex" }}
                    >
                      <input
                        type="text"
                        placeholder="Reply..."
                        name="replyContent"
                        required
                        className={`${className} flex-grow`}
                      />
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: "5px", background: mainBackground }}
                      >
                        Send
                      </Button>
                    </form>
                  )}
                  {/* Display replies for each comment */}
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: isUserSender ? "flex-end" : "flex-start",
                    }}
                  >
                    {comment?.replies && comment.replies.length > 0 && (
                      <div style={{ marginTop: "10px" }}>
                        {renderReplies(comment.replies)}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <form
        ref={chatRef}
        onSubmit={(e) => {
          e.preventDefault();
          const data = new FormData(e.currentTarget);
          submitChats({
            taskId: taskId ?? task.taskId,
            content: data.get("description"),
            subTaskId: isSubTask ? task.id : null,
          });
        }}
        className="flex mt-3"
      >
        <textarea
          rows={2}
          placeholder="Enter your comment"
          className={className}
          name="description"
          required
          style={{ marginRight: "10px", resize: "none" }}
        />
        <div>
          {sendingChats ? (
            <CircularProgress />
          ) : (
            <Button
              type="submit"
              variant="contained"
              style={{
                backgroundColor: mainBackground,
              }}
              color="primary"
            >
              Send
            </Button>
          )}
        </div>
      </form>
    </>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentManager);
